// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3qXMX","main":"styles_main__LU3lV"};